import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

/* istanbul ignore */
@Injectable({
  providedIn: 'root'
})
export class AccessKpiConfigService{

  constructor(private store: Store, private router: Router) {}

  public canActivate() {
    let kpiMode = this.store.selectSnapshot(state => state.configurations.kpi.mode);

    if(kpiMode === null){
      this.router.navigateByUrl('/home');
      return false;
    }

    return true;
  }
}
